import { handleResponse } from './handleresponse'
import { apiurl } from '@/services/config'
const API_URL = apiurl

export const UserServices = {
  gantipassword,
  updateProvile,
  getIPAPI,
  resetAPIKey,
  setIP,
  getBalance,
  verifyPhone,
  verifyProvile,
  generateQr2fa,
  verifyAct2fa,
  updateSyaratKetentuan
}
function verifyAct2fa (code) {
  return fetch(API_URL + '/api/v1/user/2fa/validate', {
    method: 'PATCH',
    body: JSON.stringify({ code: code }),
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + localStorage.getItem('token')
    }
  }).then(handleResponse)
    .then(data => {
      return data
    })
}
function generateQr2fa () {
  return fetch(API_URL + '/api/v1/user/2fa/generate', {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + localStorage.getItem('token')
    }
  }).then(handleResponse)
    .then(data => {
      return data
    })
}

function verifyPhone (postdata) {
  return fetch(API_URL + '/api/v1/user/verifyphone', {
    method: 'POST',
    body: JSON.stringify({ postdata }.postdata),
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + localStorage.getItem('token')
    }
  }).then(handleResponse)
    .then(data => {
      return data
    })
}

function updateSyaratKetentuan (postdata) {
  return fetch(API_URL + '/api/v1/user/syaratketentuan', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + localStorage.getItem('token')
    }
  }).then(handleResponse)
    .then(data => {
      return data
    })
}

function getBalance () {
  return fetch(API_URL + '/api/v1/user/balance', {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + localStorage.getItem('token')
    }
  }).then(handleResponse)
    .then(data => {
      return data
    })
}

function resetAPIKey () {
  return fetch(API_URL + '/api/v1/user/resetapikey', {
    method: 'PATCH',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + localStorage.getItem('token')
    }
  }).then(handleResponse)
    .then(data => {
      return data
    })
}
function setIP (postdata) {
  return fetch(API_URL + '/api/v1/user/api', {
    method: 'PATCH',
    body: JSON.stringify({ postdata }.postdata),
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + localStorage.getItem('token')
    }
  }).then(handleResponse)
    .then(data => {
      return data
    })
}
function getIPAPI () {
  return fetch(API_URL + '/api/v1/user/api', {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + localStorage.getItem('token')
    }
  }).then(handleResponse)
    .then(data => {
      return data
    })
}

function gantipassword (customer) {
  return fetch(API_URL + '/api/v1/user/gantipassword', {
    method: 'PATCH',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + localStorage.getItem('token')
    },
    body: JSON.stringify(customer)
  }).then(handleResponse)
}

function updateProvile (customer) {
  return fetch(API_URL + '/api/v1/user', {
    method: 'PATCH',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + localStorage.getItem('token')
    },
    body: JSON.stringify(customer)
  }).then(handleResponse)
}

function verifyProvile (customer) {
  return fetch(API_URL + '/api/v1/user/newupdate', {
    method: 'PATCH',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + localStorage.getItem('token')
    },
    body: JSON.stringify(customer)
  }).then(handleResponse)
}
